module.exports = __webpack_public_path__ + "img/Acessos_Vasculares.e596adf0.png";